import { render, staticRenderFns } from "./tableMagang.vue?vue&type=template&id=23f003f0&scoped=true"
import script from "./tableMagang.vue?vue&type=script&lang=js"
export * from "./tableMagang.vue?vue&type=script&lang=js"
import style0 from "./tableMagang.vue?vue&type=style&index=0&id=23f003f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f003f0",
  null
  
)

export default component.exports